import * as React from 'react'

function SvgHand(props) {
  return (
    <svg
      width={34}
      height={48}
      viewBox="0 0 34 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.005 14.329a7 7 0 115.99 0"
        stroke="#317AEC"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 24a3 3 0 10-6 0v7c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15v-7a3 3 0 10-6 0v-2a3 3 0 10-6 0v-2a3 3 0 10-6 0V8a3 3 0 10-6 0v22-6z"
        fill="#F1F1F1"
        stroke="#141414"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgHand
